export var DiceAdvertisingEvents;!function(e){e.CUE_POINTS_CHANGED="cuepointschanged"}(DiceAdvertisingEvents||(DiceAdvertisingEvents={}));